export default {
  GET_CAFE_CONTRACT: 'GET_CAFE_CONTRACT',
  GET_CAFE_CONTRACT_LOADING: 'GET_CAFE_CONTRACT_LOADING',
  GET_CAFE_CONTRACT_SUCCESS: 'GET_CAFE_CONTRACT_SUCCESS',
  GET_CAFE_CONTRACT_FAILED: 'GET_CAFE_CONTRACT_FAILED',
  GET_CAFE_CONTRACT_REJECT: 'GET_CAFE_CONTRACT_REJECT',

  INSERT_NEW_CAFE_CONTRACT: 'INSERT_NEW_CAFE_CONTRACT',
  INSERT_NEW_CAFE_CONTRACT_LOADING: 'INSERT_NEW_CAFE_CONTRACT_LOADING',
  INSERT_NEW_CAFE_CONTRACT_SUCCESS: 'INSERT_NEW_CAFE_CONTRACT_SUCCESS',
  INSERT_NEW_CAFE_CONTRACT_FAILED: 'INSERT_NEW_CAFE_CONTRACT_FAILED',
  INSERT_NEW_CAFE_CONTRACT_REJECT: 'INSERT_NEW_CAFE_CONTRACT_REJECT',

  CLEAR_ADD_OR_EDIT_CAFE_CONTRACT_FORM: 'CLEAR_ADD_OR_EDIT_CAFE_CONTRACT_FORM',

  GET_CITIES_CONTRACT: 'GET_CITIES_CONTRACT',
  GET_CITIES_CONTRACT_LOADING: 'GET_CITIES_CONTRACT_LOADING',
  GET_CITIES_CONTRACT_SUCCESS: 'GET_CITIES_CONTRACT_SUCCESS',
  GET_CITIES_CONTRACT_FAILED: 'GET_CITIES_CONTRACT_FAILED',
  GET_CITIES_CONTRACT_REJECT: 'GET_CITIES_CONTRACT_REJECT',

  GET_CITY_CONTRACT_LOADING: 'GET_CITY_CONTRACT_LOADING',
  GET_CITY_CONTRACT_SUCCESS: 'GET_CITY_CONTRACT_SUCCESS',
  GET_CITY_CONTRACT_FAILED:  'GET_CITY_CONTRACT_FAILED',
  GET_CITY_CONTRACT_REJECT:  'GET_CITY_CONTRACT_REJECT',

  GET_CONTRACT_BY_ID_LOADING: 'GET_CONTRACT_BY_ID_LOADING',
  GET_CONTRACT_BY_ID_SUCCESS: 'GET_CONTRACT_BY_ID_SUCCESS',
  GET_CONTRACT_BY_ID_FAILURE: 'GET_CONTRACT_BY_ID_FAILURE',
  GET_CONTRACT_BY_ID_REJECT: 'GET_CONTRACT_BY_ID_REJECT',

  UPDATE_CAFE_CONTRACT: 'UPDATE_CAFE_CONTRACT',
  UPDATE_CAFE_CONTRACT_LOADING: 'UPDATE_CAFE_CONTRACT_LOADING',
  UPDATE_CAFE_CONTRACT_SUCCESS: 'UPDATE_CAFE_CONTRACT_SUCCESS',
  UPDATE_CAFE_CONTRACT_FAILED: 'UPDATE_CAFE_CONTRACT_FAILED',
  UPDATE_CAFE_CONTRACT_REJECT: 'UPDATE_CAFE_CONTRACT_REJECT',
};
